export enum PasswordActionTypes {
  CHANGE_PASSWORD_BY_RECOVERY_TOKEN_REQUEST = 'CHANGE_PASSWORD_BY_RECOVERY_TOKEN_REQUEST',
  CHANGE_PASSWORD_BY_RECOVERY_TOKEN_SUCCEEDED = 'CHANGE_PASSWORD_BY_RECOVERY_TOKEN_SUCCEEDED',
  CHANGE_PASSWORD_BY_RECOVERY_TOKEN_FAILED = 'CHANGE_PASSWORD_BY_RECOVERY_TOKEN_FAILED',

  FORGET_PASSWORD_REQUEST = 'FORGET_PASSWORD_REQUEST',
  FORGET_PASSWORD_SUCCEEDED = 'FORGET_PASSWORD_SUCCEEDED',
  FORGET_PASSWORD_FAILED = 'FORGET_PASSWORD_FAILED',

  VALIDATE_TOKEN = 'VALIDATE_TOKEN',
  VALIDATE_TOKEN_REQUEST = 'VALIDATE_TOKEN_REQUEST',
  VALIDATE_TOKEN_SUCCEEDED = 'VALIDATE_TOKEN_SUCCEEDED',
  VALIDATE_TOKEN_FAILED = 'VALIDATE_TOKEN_FAILED',

  LOGIN_RESET_STATE = 'LOGIN_RESET_STATE',
}
